import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { useTranslation } from "react-i18next";

export default function Header({ colorVariant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const { i18n, t } = useTranslation(["nav"]);

  const handleScrollToTop = () => {
    scroll.scrollToTop();
  };

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  useEffect(() => {
    i18n.changeLanguage("he");
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleNavItemClick = () => {
    setMobileToggle(false);
  };

  const languageButton = i18n.language === "en" ? "he" : "en";

  const navbarItems =
    i18n.language === "en"
      ? [
          { label: t("home"), target: "top", onClick: handleScrollToTop },
          {
            label: t("whoweare"),
            target: "about",
            onClick: handleNavItemClick,
          },
          {
            label: t("service"),
            target: "service",
            onClick: handleNavItemClick,
          },
          {
            label: t("recommend"),
            target: "recommendation",
            onClick: handleNavItemClick,
          },
          { label: t("blog"), to: "/blog-list", onClick: handleNavItemClick },
          {
            label: t("contact"),
            target: "contact",
            onClick: handleNavItemClick,
          },
        ]
      : [
          {
            label: t("contact"),
            target: "contact",
            onClick: handleNavItemClick,
          },
          { label: t("blog"), to: "/blog-list", onClick: handleNavItemClick },
          {
            label: t("recommend"),
            target: "recommendation",
            onClick: handleNavItemClick,
          },
          {
            label: t("service"),
            target: "service",
            onClick: handleNavItemClick,
          },
          {
            label: t("whoweare"),
            target: "about",
            onClick: handleNavItemClick,
          },
          { label: t("home"), target: "top", onClick: handleScrollToTop },
        ];

  return (
    <header
      className={`cs_site_header cs_style_1 ${
        colorVariant ? colorVariant : "cs_primary_color"
      } ${isSticky ? "cs_gescout_show" : "cs_sticky_header"}`}
    >
      <div className="cs_main_header">
        <div className="container">
          <div className="cs_main_header_in">
            <div className="cs_main_header_left">
              <RouterLink to="/">
                <img alt="" src="/others-image/Halisi-white1.png" />
              </RouterLink>
            </div>
            <div className="cs_main_header_center">
              <div className="cs_nav cs_medium cs_primary_font">
                <ul
                  className={`${
                    mobileToggle ? "cs_nav_list cs_active" : "cs_nav_list"
                  }`}
                >
                  {navbarItems.map((item, index) => (
                    <li key={index}>
                      {item.target ? (
                        <ScrollLink
                          to={item.target}
                          smooth={true}
                          duration={500}
                          onClick={item.onClick}
                          onMouseEnter={(e) =>
                            (e.target.style.color = "#005D9F")
                          }
                          onMouseLeave={(e) => (e.target.style.color = "#fff")}
                        >
                          {item.label}
                        </ScrollLink>
                      ) : (
                        <RouterLink to={item.to} onClick={item.onClick}>
                          {item.label}
                        </RouterLink>
                      )}
                    </li>
                  ))}
                </ul>
                <span
                  className={`${
                    mobileToggle
                      ? "cs_menu_toggle cs_toggle_active"
                      : "cs_menu_toggle"
                  }`}
                  onClick={() => setMobileToggle(!mobileToggle)}
                >
                  <span></span>
                </span>
              </div>
            </div>
            <div className="cs_main_header_right">
              <button
                onClick={() => changeLanguage(languageButton)}
                className={`cs_btn cs_style_1  ${
                  colorVariant ? "cs_btn_white" : ""
                }`}
              >
                {languageButton === "en" ? "English" : "עברית (Hebrew)"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
